export default function setFlag(name) {
  this.setVarValue(name, true);
}